











































import { Component, Mixins } from "vue-property-decorator";
import UserMixin from "@/mixins/userMixin";
import Cookies from "js-cookie";
import AxiosMixin from "@/mixins/axiosMixin";
import FireStoreMixin from "#/mixins/firestoreMixin";
import { COLLECTION_ASSIGN_MEMBER_UPDATE } from "@/consts/envFireStore";
import { firebase, signOutFromFirebase } from "#/mixins/firebase";

@Component
export default class AppMenu extends Mixins(
  UserMixin,
  AxiosMixin,
  FireStoreMixin
) {
  /** スナップショットのリスナー */
  private unsubscribeAssignListener: (() => void) | null = null;

  /** Firebase認証リスナー（onSnapshot再購読用） */
  private unsubscribeAuthListener: (() => void) | null = null;

  /** アサイン可能かどうか */
  private is_assignable = false;

  /** アサイン状態 */
  private assignUser: { id: number; status: number } = { id: 0, status: 0 };

  /** 受付可能状態かどうか */
  private get AttendanceStatus(): boolean {
    return this.assignUser.id !== 0 && this.assignUser.status === 1;
  }

  created() {
    this.postJsonNoloading(
      window.base_url + "/api/admin/assign_admin_user/get",
      {},
      (res) => {
        // 自分のアサイン情報取得
        this.assignUser = res.data.assign_admin_user;
        this.is_assignable = res.data.is_assignable;
        if (this.is_assignable) {
          this.subscribeAssignListener();
        }
      }
    );
  }

  beforeDestroy() {
    if (this.unsubscribeAssignListener) {
      this.unsubscribeAssignListener();
      this.unsubscribeAssignListener = null;
    }
    if (this.unsubscribeAuthListener) {
      this.unsubscribeAuthListener();
      this.unsubscribeAuthListener = null;
    }
  }

  /** アサイン状態の Firestore リスナーを開始する */
  private subscribeAssignListener() {
    if (this.unsubscribeAssignListener) {
      this.unsubscribeAssignListener();
    }
    this.unsubscribeAssignListener = this.getFirestoreDB()
      .collection(COLLECTION_ASSIGN_MEMBER_UPDATE)
      .doc("1")
      .onSnapshot(
        () => {
          this.postJsonNoloading(
            window.base_url + "/api/admin/assign_admin_user/get",
            {},
            (res) => {
              this.assignUser = res.data.assign_admin_user;
              this.is_assignable = res.data.is_assignable;
            }
          );
        },
        (error) => {
          // Firebase 未認証による拒否の場合、未認証→認証済みへの遷移時のみ再購読する
          // （認証済みでの拒否でリスナーが即通知→再購読のループになるのを防ぐ）
          if (error.code === "permission-denied" && !this.unsubscribeAuthListener) {
            const prevUser = firebase.auth().currentUser;
            this.unsubscribeAuthListener = firebase.auth().onAuthStateChanged((user) => {
              if (user && !prevUser) {
                if (this.unsubscribeAuthListener) {
                  this.unsubscribeAuthListener();
                  this.unsubscribeAuthListener = null;
                }
                this.subscribeAssignListener();
              }
            });
          }
        }
      );
  }

  //ログアウト
  private async logout() {
    if (!(await this.$openConfirm("ログアウトしますか？"))) {
      return;
    }
    await signOutFromFirebase();
    window.token = "";
    Cookies.set("admin-token", "");
    window.reftoken = "";
    Cookies.set("admin-reftoken", "");
    location.href = "/";
  }
}
